// Module
var code = "<div class=\"u-sizeFullWidth ui-grid-cell-contents\">\n    <div class=\"u-flex u-flexMiddle u-flexSpaced\">\n        <div ng-bind=\"row.entity.Ordered | date :'short'\"></div>\n    </div>\n</div>";
// Exports
module.exports = code;